import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const ProgressModal = ({ isVisible, count, linkTo, linkLabel }) => {
  if (!isVisible) {
    return null;
  }

  const itemLabel = count === 1 ? 'item' : 'items';

  return (
    <div
      className="fixed bottom-6 left-1/2 z-40 w-full max-w-lg -translate-x-1/2 px-4"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-4 rounded-2xl border border-orange-200 bg-white/95 px-5 py-4 shadow-lg backdrop-blur">
        <div className="flex flex-col">
          <span className="text-xs font-semibold uppercase tracking-wide text-orange-500">Kit Progress</span>
          <span className="text-lg font-semibold text-gray-900">
            {count} {itemLabel} selected
          </span>
        </div>
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1 rounded-full bg-orange-500 px-4 py-2 text-sm font-semibold uppercase tracking-wide text-white shadow hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
        >
          {linkLabel}
          <ChevronRight size={18} />
        </Link>
      </div>
    </div>
  );
};

export default ProgressModal;
